import IconAlert from "app/components/Icon/components/IconAlert/IconAlert";
import { FormattedMessage } from "react-intl";

type Props = {
  accountSettingsValidationErrorMessage: string;
};

const ValidationErrorMessage = ({
  accountSettingsValidationErrorMessage,
}: Props) => {
  return (
    <div className="form-details__row form-details__validation-error">
      <div className="information-needed">
        <span className="spacer">
          <IconAlert />
        </span>
        <FormattedMessage tagName="span" id="registration-information-needed" />
      </div>
      <div className="validation-error-message">
        <span className="spacer">&nbsp;</span>
        <span>{accountSettingsValidationErrorMessage}</span>
      </div>
    </div>
  );
};

export default ValidationErrorMessage;
